

export class CostReviewSecurityEnUsNetwork {
  isNetworkChecked!: boolean;
  networkStyle!: number;
  networkOptions!: number[];
}
